export type User = {
  id: number
  nik: string
  phoneNumber: string
  fullName: string
  accountNumber: string
  joinDate: string
  submissionDate: string
  kycStatus: string
}

export type ResponseUser = {
  id: number
  contact_no: string
  full_name: string
  NRIC: string
  created_at: string
  submission_date: string
  kyc_status: string
  account_number: string
}

export type KycDetails = {
  nik: string
  phoneNumber: string
  fullName: string
  accountNumber: string
  joinDate: string
  kycStatus: string
  kycRejectedReason: string[]
  gender: string
  placeOfBirth: string
  dateOfBirth: string
  nationality: string
  motherMaidenName: string
  religion: string
  maritalStatus: string
  address1: string
  address2: string
  village: string
  district: string
  city: string
  province: string
  country: string
  idFrontUrl: string
  selfieUrl: string
}

export type FilterOptions = {
  userStatuses: Array<{ label: string; value: string }>
}

export type FilterValues = {
  currentPage: number
  searchString: string

  userStatuses: string[]
}

export type OptionProps = {
  label: string
  value: string
}

export enum MERCHANT_USERS_ACTIONS {
  SET_SUB_USERS = 'MERCHANT_USERS_ACTIONS.SET_SUB_USERS',
  SET_FILTERS = 'MERCHANT_USERS_ACTIONS.SET_FILTERS',
  SET_IS_USER_TABLE_LOADING = 'MERCHANT_USERS_ACTIONS.SET_IS_USER_TABLE_LOADING',
  RESET_CURRENT_PAGE = 'MERCHANT_USERS_ACTIONS.RESET_CURRENT_PAGE',
  SET_KYC_MODAL_OPEN = 'MERCHANT_USERS_ACTIONS.SET_KYC_MODAL_OPEN',
  SET_KYC_MODAL_CLOSED = 'MERCHANT_USERS_ACTIONS.SET_KYC_MODAL_CLOSED',
  SET_KYC_DETAILS = 'MERCHANT_USERS_ACTIONS.SET_KYC_DETAILS',
}

type SetSubUsers = {
  type: typeof MERCHANT_USERS_ACTIONS.SET_SUB_USERS
  users: User[]
  totalCount: number
}

type SetFilters = {
  type: typeof MERCHANT_USERS_ACTIONS.SET_FILTERS
  filterKey: string
  filterValues: string | number | string[]
}

type ResetCurrentPage = {
  type: typeof MERCHANT_USERS_ACTIONS.RESET_CURRENT_PAGE
}

type SetIsUserTableLoading = {
  type: typeof MERCHANT_USERS_ACTIONS.SET_IS_USER_TABLE_LOADING
  isLoading: boolean
}

type SetKycModalOpen = {
  type: typeof MERCHANT_USERS_ACTIONS.SET_KYC_MODAL_OPEN
  isOpen: boolean
  isKycLoading: boolean
  currentUserId: number
}

type SetKycModalClosed = {
  type: typeof MERCHANT_USERS_ACTIONS.SET_KYC_MODAL_CLOSED
  isOpen: boolean
}

type SetKycDetails = {
  type: typeof MERCHANT_USERS_ACTIONS.SET_KYC_DETAILS
  kycDetails: KycDetails
  isKycLoading: boolean
}

export type ActionTypes =
  | SetSubUsers
  | SetFilters
  | ResetCurrentPage
  | SetIsUserTableLoading
  | SetKycModalOpen
  | SetKycModalClosed
  | SetKycDetails
